enum IntegrationBindingType {
  Password = 'Password',
  OAuth = 'OAuth',
  Token = 'Token',
}

export default IntegrationBindingType;
